import React from "react";

import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import CheckCircle from "../../../Utils/Assets/Images/CheckCircle2.png";
import CoinsVideo from "../../../Utils/Assets/Images/coins-rotating.webm";
const NextEvolution = () => {
    return (
        <div className={styles.container}>
            <MeetUsWrapper>
                <div className={styles.cardBorderWrapper}>
                    <div className={styles.cardBorder}>
                        <div className={styles.cardFlex}>
                            {/* Text */}
                            <div
                                className={styles.flexCol}
                                data-aos="fade-right"
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <div className={styles.subtext}>
                                    <p className={styles.title}>
                                        Coming Soon: The Next Evolution in Real Estate Investing
                                    </p>
                                    <div className={styles.checkWrapper}>
                                        <img
                                            src={CheckCircle}
                                            alt="Check Circle"
                                            className={styles.checkCircle}
                                        />
                                        <p className={styles.checkText}>
                                            Integration with real estate
                                            marketplaces & property developers.
                                        </p>
                                    </div>
                                    <div className={styles.checkWrapper}>
                                        <img
                                            src={CheckCircle}
                                            alt="Check Circle"
                                            className={styles.checkCircle}
                                        />
                                        <p className={styles.checkText}>
                                            Launch of real estate staking and
                                            rental income rewards.
                                        </p>
                                    </div>
                                    <div className={styles.checkWrapper}>
                                        <img
                                            src={CheckCircle}
                                            alt="Check Circle"
                                            className={styles.checkCircle}
                                        />
                                        <p className={styles.checkText}>
                                            Seamless tokenized property
                                            transactions via smart contracts.
                                        </p>
                                    </div>
                                    <div className={styles.buttonRight}>
                                        <button>Be the First to Invest in Tokenized Real Estate!</button>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.videoContainer}>
                                <video
                                    src={CoinsVideo}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className={styles.coinsVideo}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                ></video>
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default NextEvolution;
